var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgError = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1584_1035)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 53.5232C42.0961 53.5232 53.5232 42.0961 53.5232 28C53.5232 13.904 42.0961 2.47685 28 2.47685C13.904 2.47685 2.47685 13.904 2.47685 28C2.47685 42.0961 13.904 53.5232 28 53.5232ZM28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "#D32F2F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 53.5232C42.0961 53.5232 53.5232 42.0961 53.5232 28C53.5232 13.904 42.0961 2.47685 28 2.47685C13.904 2.47685 2.47685 13.904 2.47685 28C2.47685 42.0961 13.904 53.5232 28 53.5232ZM28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.0001,
    cy: 28,
    r: 20.5333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.0001,
    cy: 28,
    r: 20.5333,
    fill: "#D32F2F",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.2007,
    y: 14.9333,
    width: 5.6,
    height: 16.8,
    fill: "#D32F2F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.2007,
    y: 14.9333,
    width: 5.6,
    height: 16.8,
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.2007,
    y: 35.0497,
    width: 5.6,
    height: 5.6,
    fill: "#D32F2F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.2007,
    y: 35.0497,
    width: 5.6,
    height: 5.6,
    fill: "black",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1584_1035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error.013358b3d18e0b3399970ec35c9cf458.svg";